module.exports = __webpack_public_path__ + "static/media/digdes.e998024e.png";